(function(angular) {
    angular.module('wtApp.wtTracking.errorHandler', [
        'wtApp.wtTracking.tracking'
    ]).config(['$qProvider', function($qProvider) {
        $qProvider.errorOnUnhandledRejections(false);
    }]);
})(window.angular);
